/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SubmitInputs */

const en_common_submit = /** @type {(inputs: Common_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const fr_common_submit = /** @type {(inputs: Common_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Common_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const common_submit = /** @type {((inputs?: Common_SubmitInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SubmitInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_submit(inputs)
	return fr_common_submit(inputs)
});